import React from 'react';
import classNames from 'classnames';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './Callout.module.scss';

export const calloutVariants = {
  info: 'info',
  tip: 'tip',
};

export const CalloutComponent = ({
  variant = calloutVariants.info,
  icon,
  title,
  children,
  className,
}) => (
  <div
    className={classNames(
      styles.callout,
      { [styles[`callout_variant_${variant}`]]: variant },
      className
    )}
  >
    {icon && <span className={styles.iconWrap}>{icon}</span>}
    <div className={styles.content}>
      {title && (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Semibold}
          className={styles.title}
        >
          {title}
        </Text>
      )}
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Normal}
        className={styles.message}
      >
        {children}
      </Text>
    </div>
  </div>
);

CalloutComponent.displayName = 'Callout';
